import {useCallback} from 'react';

import {DocumentStore} from '../../store/document-store';
import {useOnDocumentInfoChange} from './use-on-document-info-change';
import {useOnDocumentLocaleChange} from './use-on-document-locale-change';

export const useOnDocumentModelChange = () => {
  const onDocumentLocaleChange = useOnDocumentLocaleChange();
  const onDocumentInfoChange = useOnDocumentInfoChange();

  return useCallback(
    (changedKeys: string[], state: DocumentStore) => {
      // Update document locale when the store changes
      onDocumentLocaleChange(changedKeys, state);

      // Update document name and type when the store changes
      onDocumentInfoChange(changedKeys, state);
    },
    [onDocumentInfoChange, onDocumentLocaleChange],
  );
};
